var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"twin"},[_c('div',{staticClass:"tips"},[_vm._v("典型客户")]),_c('div',[_vm._v("众多品牌的一致认可")]),_c('div',{staticClass:"twinMain"},_vm._l((_vm.serviceList),function(item,index){return _c('div',{key:index,staticClass:"every"},[_c('img',{attrs:{"src":item.img,"alt":""}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }